import {
  GEO_FETCH_COUNTRIES_SUCCESS,
  GEO_FETCH_COUNTRIES_ERROR,
  GEO_FETCH_REGIONS_SUCCESS,
  GEO_FETCH_REGIONS_ERROR,
  GEO_FETCH_CITIES_SUCCESS,
  GEO_FETCH_CITIES_ERROR
} from "../actions/geoActions";

const initialState = {
  countries: {},
  regions: {},
  subregions: {},
  cities: {},
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GEO_FETCH_COUNTRIES_ERROR:
    case GEO_FETCH_REGIONS_ERROR:
    case GEO_FETCH_CITIES_ERROR:
      return {...state, error: action.payload};
    case GEO_FETCH_COUNTRIES_SUCCESS:
      return {...state, countries: action.payload, regions: {}, subregions: {}, cities: {}}
    case GEO_FETCH_REGIONS_SUCCESS:
      return {...state, regions: action.payload, subregions: {}, cities: {}}
    case GEO_FETCH_CITIES_SUCCESS:
      return {...state, cities: action.payload}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/geoReducer.js